import { useEffect, useState } from "react";
import { App, type AppInfo } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

import { formatBuildLabel } from "./BuildStamp";

/**
 * Native-only About block. The web build and binary build move independently because the shell
 * follows Pages between TestFlight releases; showing both makes every dogfood report actionable.
 */
export function NativeShellAbout({
  webVersion = typeof __APP_VERSION__ === "string" ? __APP_VERSION__ : "26.08.0001",
}: {
  webVersion?: string;
}) {
  const [nativeIos] = useState(
    () => Capacitor.isNativePlatform() && Capacitor.getPlatform() === "ios",
  );
  const [appInfo, setAppInfo] = useState<AppInfo | "error" | null>(null);

  useEffect(() => {
    if (!nativeIos) return;
    let active = true;
    void App.getInfo()
      .then((info) => {
        if (active) setAppInfo(info);
      })
      .catch(() => {
        if (active) setAppInfo("error");
      });
    return () => {
      active = false;
    };
  }, [nativeIos]);

  if (!nativeIos) return null;

  return (
    <dl className="shellabout" aria-label="SecOps Console build information">
      <div>
        <dt>Web</dt>
        <dd>{formatBuildLabel(webVersion)}</dd>
      </div>
      <div>
        <dt>iOS shell</dt>
        <dd>
          {appInfo === null
            ? "checking…"
            : appInfo === "error"
              ? "unavailable"
              : `${appInfo.version} (${appInfo.build})`}
        </dd>
      </div>
    </dl>
  );
}
